function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#3C3C3B",
  cx: 100,
  cy: 100,
  r: 100
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M62.377,58.811l-1.001,0.767c-0.548-0.717-1.213-1.261-1.981-1.632c-0.774-0.368-1.618-0.552-2.545-0.552 c-1.012,0-1.942,0.242-2.805,0.725c-0.857,0.483-1.526,1.136-2.003,1.953c-0.473,0.817-0.709,1.738-0.709,2.762 c0,1.542,0.53,2.829,1.587,3.862c1.059,1.033,2.397,1.549,4.008,1.549c1.774,0,3.259-0.695,4.448-2.083l1.001,0.76 c-0.633,0.8-1.42,1.421-2.363,1.861c-0.946,0.438-2.001,0.657-3.164,0.657c-2.214,0-3.958-0.736-5.243-2.209 C50.533,65.984,50,64.48,50,62.719c0-1.851,0.648-3.412,1.949-4.676c1.3-1.267,2.926-1.898,4.881-1.898 c1.183,0,2.251,0.234,3.203,0.7C60.983,57.313,61.77,57.969,62.377,58.811"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "80.239,69.123 80.239,56.461 80.519,56.461 88.94,66.168 88.94,56.461 90.189,56.461 90.189,69.123  89.907,69.123 81.548,59.538 81.548,69.123 "
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "92.012,57.703 92.012,56.461 98.95,56.461 98.95,57.703 96.127,57.703 96.127,69.123 94.838,69.123  94.838,57.703 "
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M104.521,56.461l5.902,12.662h-1.366l-1.992-4.166h-5.458l-1.967,4.166h-1.412l5.984-12.662H104.521z  M104.361,59.152l-2.173,4.582h4.329L104.361,59.152z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "111.809,69.123 113.619,56.461 113.824,56.461 118.971,66.849 124.068,56.461 124.271,56.461  126.094,69.123 124.854,69.123 123.603,60.067 119.127,69.123 118.803,69.123 114.271,59.999 113.031,69.123 "
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M142.591,66.764l1.075-0.644c0.762,1.396,1.633,2.09,2.625,2.09c0.425,0,0.824-0.099,1.195-0.297 c0.373-0.197,0.659-0.462,0.853-0.796c0.197-0.331,0.296-0.684,0.296-1.057c0-0.424-0.146-0.842-0.433-1.25 c-0.396-0.56-1.116-1.239-2.167-2.03c-1.061-0.798-1.713-1.373-1.973-1.73c-0.447-0.596-0.67-1.243-0.67-1.936 c0-0.55,0.133-1.052,0.394-1.504c0.263-0.455,0.635-0.813,1.116-1.074c0.479-0.261,1-0.39,1.561-0.39 c0.601,0,1.158,0.148,1.676,0.444c0.52,0.294,1.066,0.838,1.647,1.63L148.756,59c-0.48-0.63-0.886-1.045-1.221-1.246 c-0.334-0.201-0.703-0.301-1.098-0.301c-0.511,0-0.928,0.155-1.25,0.464c-0.324,0.31-0.486,0.688-0.486,1.144 c0,0.274,0.054,0.543,0.174,0.799c0.111,0.259,0.324,0.539,0.624,0.846c0.171,0.157,0.713,0.582,1.637,1.262 c1.095,0.81,1.847,1.53,2.253,2.163c0.41,0.63,0.611,1.263,0.611,1.9c0,0.917-0.348,1.717-1.044,2.393s-1.546,1.014-2.544,1.014 c-0.77,0-1.465-0.205-2.09-0.615C143.694,68.414,143.119,67.729,142.591,66.764"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M62.377,109.78l-1.001,0.767c-0.548-0.717-1.213-1.26-1.981-1.631c-0.774-0.368-1.618-0.553-2.545-0.553 c-1.012,0-1.942,0.241-2.805,0.725c-0.857,0.482-1.526,1.137-2.003,1.953c-0.473,0.817-0.709,1.738-0.709,2.763 c0,1.542,0.53,2.828,1.587,3.861c1.059,1.032,2.397,1.549,4.008,1.549c1.774,0,3.259-0.695,4.448-2.083l1.001,0.76 c-0.633,0.801-1.42,1.422-2.363,1.861c-0.946,0.438-2.001,0.657-3.164,0.657c-2.214,0-3.958-0.736-5.243-2.21 c-1.073-1.246-1.606-2.75-1.606-4.512c0-1.851,0.648-3.411,1.949-4.675c1.3-1.267,2.926-1.898,4.881-1.898 c1.183,0,2.251,0.234,3.203,0.7C60.983,108.282,61.77,108.938,62.377,109.78"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "80.239,120.093 80.239,107.432 80.519,107.432 88.94,117.139 88.94,107.432 90.189,107.432  90.189,120.093 89.907,120.093 81.548,110.508 81.548,120.093 "
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "92.012,108.672 92.012,107.431 98.95,107.431 98.95,108.672 96.127,108.672 96.127,120.093  94.838,120.093 94.838,108.672 "
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M104.521,107.431l5.902,12.662h-1.366l-1.992-4.166h-5.458l-1.967,4.166h-1.412l5.984-12.662H104.521z  M104.361,110.121l-2.173,4.582h4.329L104.361,110.121z"
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "111.809,120.093 113.619,107.432 113.824,107.432 118.971,117.818 124.068,107.432 124.271,107.432  126.094,120.093 124.854,120.093 123.603,111.036 119.127,120.093 118.803,120.093 114.271,110.968 113.031,120.093 "
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M142.591,117.733l1.075-0.644c0.762,1.395,1.633,2.09,2.625,2.09c0.425,0,0.824-0.1,1.195-0.298 c0.373-0.197,0.659-0.463,0.853-0.796c0.197-0.332,0.296-0.684,0.296-1.059c0-0.423-0.146-0.841-0.433-1.248 c-0.396-0.561-1.116-1.24-2.167-2.03c-1.061-0.798-1.713-1.373-1.973-1.729c-0.447-0.596-0.67-1.243-0.67-1.937 c0-0.551,0.133-1.052,0.394-1.504c0.263-0.455,0.635-0.813,1.116-1.075c0.479-0.26,1-0.39,1.561-0.39 c0.601,0,1.158,0.147,1.676,0.444c0.52,0.293,1.066,0.838,1.647,1.629l-1.03,0.783c-0.48-0.631-0.886-1.045-1.221-1.246 c-0.334-0.201-0.703-0.301-1.098-0.301c-0.511,0-0.928,0.155-1.25,0.464c-0.324,0.31-0.486,0.688-0.486,1.145 c0,0.274,0.054,0.544,0.174,0.799c0.111,0.259,0.324,0.539,0.624,0.847c0.171,0.156,0.713,0.581,1.637,1.262 c1.095,0.81,1.847,1.529,2.253,2.163c0.41,0.63,0.611,1.263,0.611,1.899c0,0.917-0.348,1.718-1.044,2.393 c-0.696,0.676-1.546,1.015-2.544,1.015c-0.77,0-1.465-0.204-2.09-0.614C143.694,119.383,143.119,118.697,142.591,117.733"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "50,129.025 50,126.825 62.32,126.825 62.32,129.025 57.317,129.025 57.317,149.291 55.011,149.291  55.011,129.025 "
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M91.509,149.291v-22.466h4.65c3.357,0,5.79,0.266,7.321,0.804c2.173,0.771,3.877,2.09,5.104,3.975 c1.233,1.881,1.831,4.131,1.831,6.735c0,2.255-0.471,4.233-1.454,5.94c-0.974,1.709-2.229,2.975-3.78,3.793 c-1.551,0.82-3.728,1.219-6.538,1.219H91.509z M93.642,147.168h2.61c3.098,0,5.266-0.185,6.457-0.585 c1.697-0.542,3.013-1.532,3.987-2.956c0.971-1.436,1.445-3.188,1.445-5.241c0-2.183-0.519-4.023-1.56-5.567 c-1.048-1.532-2.525-2.582-4.39-3.156c-1.4-0.43-3.722-0.641-6.955-0.641h-1.596V147.168z"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M136.842,145.106l1.914-1.142c1.34,2.475,2.892,3.703,4.653,3.703c0.757,0,1.475-0.165,2.132-0.523 c0.656-0.344,1.162-0.822,1.516-1.416c0.345-0.58,0.516-1.211,0.516-1.869c0-0.764-0.257-1.494-0.769-2.215 c-0.71-1.003-1.977-2.201-3.841-3.613c-1.885-1.416-3.041-2.433-3.501-3.068c-0.804-1.061-1.189-2.201-1.189-3.438 c0-0.977,0.22-1.863,0.698-2.676c0.457-0.806,1.125-1.434,1.978-1.898c0.849-0.463,1.775-0.695,2.767-0.695 c1.066,0,2.054,0.261,2.976,0.784c0.931,0.53,1.905,1.494,2.933,2.894l-1.84,1.391c-0.837-1.116-1.563-1.855-2.164-2.205 c-0.586-0.361-1.238-0.539-1.934-0.539c-0.914,0-1.648,0.27-2.237,0.826c-0.576,0.543-0.856,1.222-0.856,2.023 c0,0.491,0.109,0.97,0.313,1.421c0.203,0.462,0.572,0.97,1.101,1.497c0.304,0.295,1.278,1.044,2.919,2.243 c1.938,1.44,3.266,2.727,3.988,3.842c0.73,1.127,1.088,2.246,1.088,3.379c0,1.627-0.621,3.05-1.859,4.241 c-1.235,1.203-2.736,1.801-4.502,1.801c-1.379,0-2.617-0.36-3.717-1.085C138.809,148.041,137.777,146.814,136.842,145.106"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "50,78.024 50,75.824 62.32,75.824 62.32,78.024 57.317,78.024 57.317,98.302 55.011,98.302  55.011,78.024 "
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M91.501,98.29V75.821h4.658c3.361,0,5.79,0.267,7.321,0.808c2.173,0.766,3.877,2.087,5.104,3.972 c1.238,1.886,1.831,4.132,1.831,6.738c0,2.25-0.471,4.231-1.454,5.941c-0.974,1.718-2.229,2.973-3.78,3.791 s-3.724,1.218-6.538,1.218H91.501z M93.642,96.169h2.61c3.103,0,5.263-0.191,6.457-0.575c1.699-0.558,3.013-1.544,3.987-2.972 c0.971-1.433,1.445-3.186,1.445-5.239c0-2.166-0.519-4.021-1.563-5.564c-1.044-1.536-2.521-2.583-4.386-3.159 c-1.404-0.429-3.722-0.637-6.955-0.637h-1.596V96.169z"
});

var _ref20 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M124.759,75.821l10.484,22.468h-2.428l-3.529-7.388h-9.689l-3.499,7.388h-2.502l10.609-22.468H124.759z  M124.486,80.599l-3.861,8.13h7.691L124.486,80.599z"
});

var _ref21 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M136.842,94.103l1.914-1.14c1.34,2.48,2.892,3.702,4.653,3.702c0.757,0,1.475-0.166,2.132-0.521 c0.656-0.344,1.162-0.818,1.516-1.404c0.345-0.605,0.516-1.226,0.516-1.879c0-0.753-0.257-1.495-0.769-2.217 c-0.71-1.003-1.977-2.202-3.841-3.612c-1.885-1.413-3.041-2.433-3.501-3.07c-0.804-1.06-1.189-2.204-1.189-3.436 c0-0.978,0.22-1.861,0.698-2.678c0.457-0.802,1.125-1.429,1.978-1.894c0.849-0.463,1.775-0.696,2.767-0.696 c1.066,0,2.054,0.261,2.976,0.782c0.931,0.533,1.905,1.494,2.933,2.891l-1.84,1.393c-0.837-1.115-1.563-1.855-2.164-2.205 c-0.586-0.359-1.238-0.538-1.934-0.538c-0.914,0-1.648,0.268-2.237,0.827c-0.576,0.546-0.856,1.222-0.856,2.022 c0,0.503,0.109,0.968,0.313,1.421c0.203,0.463,0.572,0.968,1.101,1.508c0.304,0.287,1.278,1.031,2.919,2.243 c1.938,1.43,3.266,2.717,3.988,3.832c0.73,1.125,1.088,2.245,1.088,3.381c0,1.626-0.621,3.044-1.859,4.25 c-1.235,1.193-2.736,1.791-4.502,1.791c-1.379,0-2.617-0.359-3.717-1.09C138.809,97.039,137.777,95.827,136.842,94.103"
});

var _ref22 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M134.691,56.145c-3.684,0-6.67,2.976-6.67,6.647s2.986,6.647,6.67,6.647s6.67-2.976,6.67-6.647 S138.375,56.145,134.691,56.145z M134.691,68.209c-2.961,0-5.361-2.425-5.361-5.417s2.4-5.417,5.361-5.417s5.361,2.425,5.361,5.417 S137.652,68.209,134.691,68.209z"
});

var _ref23 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M134.691,107.114c-3.684,0-6.67,2.977-6.67,6.647c0,3.672,2.986,6.647,6.67,6.647s6.67-2.976,6.67-6.647 C141.361,110.091,138.375,107.114,134.691,107.114z M134.691,119.18c-2.961,0-5.361-2.426-5.361-5.418s2.4-5.417,5.361-5.417 s5.361,2.425,5.361,5.417S137.652,119.18,134.691,119.18z"
});

var _ref24 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M71.023,56.145c-3.684,0-6.67,2.976-6.67,6.647s2.986,6.647,6.67,6.647s6.67-2.976,6.67-6.647 S74.707,56.145,71.023,56.145z M71.023,68.209c-2.961,0-5.361-2.425-5.361-5.417s2.4-5.417,5.361-5.417s5.361,2.425,5.361,5.417 S73.984,68.209,71.023,68.209z"
});

var _ref25 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M71.023,107.114c-3.684,0-6.67,2.977-6.67,6.647c0,3.672,2.986,6.648,6.67,6.648s6.67-2.977,6.67-6.648 C77.693,110.091,74.707,107.114,71.023,107.114z M71.023,119.18c-2.961,0-5.361-2.426-5.361-5.418s2.4-5.417,5.361-5.417 s5.361,2.425,5.361,5.417S73.984,119.18,71.023,119.18z"
});

var _ref26 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M75.985,75.25c-6.542,0-11.845,5.286-11.845,11.806c0,6.521,5.304,11.807,11.845,11.807 S87.83,93.576,87.83,87.056C87.83,80.536,82.526,75.25,75.985,75.25z M75.985,96.677c-5.258,0-9.521-4.308-9.521-9.621 c0-5.314,4.263-9.62,9.521-9.62s9.521,4.306,9.521,9.62C85.506,92.369,81.243,96.677,75.985,96.677z"
});

var _ref27 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M75.985,126.25c-6.542,0-11.845,5.286-11.845,11.806c0,6.521,5.304,11.807,11.845,11.807 s11.845-5.286,11.845-11.807C87.83,131.536,82.526,126.25,75.985,126.25z M75.985,147.677c-5.258,0-9.521-4.308-9.521-9.621 c0-5.314,4.263-9.62,9.521-9.62s9.521,4.306,9.521,9.62C85.506,143.369,81.243,147.677,75.985,147.677z"
});

var _ref28 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M124.417,126.25c-6.541,0-11.845,5.286-11.845,11.806c0,6.521,5.304,11.807,11.845,11.807 c6.542,0,11.845-5.286,11.845-11.807C136.262,131.536,130.959,126.25,124.417,126.25z M124.417,147.677 c-5.258,0-9.521-4.308-9.521-9.621c0-5.314,4.263-9.62,9.521-9.62c5.259,0,9.521,4.306,9.521,9.62 C133.938,143.369,129.676,147.677,124.417,147.677z"
});

var SvgDeclinaImg = function SvgDeclinaImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeclinaImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/declina_img.94d79629.svg";
export { ForwardRef as ReactComponent };